import { Button, Card, Col, Divider, Layout, Row, Space, Typography, Tag } from "antd";
import { DollarOutlined, GoldOutlined, RocketOutlined, CheckOutlined} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;
const { Content, Footer } = Layout;

const packages = [
  {
    name: "Starter",
    price: "$29",
    period: "/month",
    description: "Perfect for small shops getting started",
    icon: <DollarOutlined style={{ fontSize: 32, color: "#52c41a" }} />,
    features: [
      { text: "Up to 500 products", included: true },
      { text: "Basic sales tracking", included: true },
      { text: "Single location", included: true },
      { text: "Email support", included: true },
      { text: "Warehouse integration", included: false },
      { text: "Advanced reporting", included: false },
    ],
    popular: false,
  },
  {
    name: "Professional",
    price: "$79",
    period: "/month",
    description: "For growing retail businesses",
    icon: <GoldOutlined style={{ fontSize: 32, color: "#faad14" }} />,
    features: [
      { text: "Up to 5,000 products", included: true },
      { text: "Advanced sales analytics", included: true },
      { text: "3 locations", included: true },
      { text: "Priority support", included: true },
      { text: "Warehouse integration", included: true },
      { text: "Advanced reporting", included: false },
    ],
    popular: true,
  },
  {
    name: "Enterprise",
    price: "$199",
    period: "/month",
    description: "For multi-store retail chains",
    icon: <RocketOutlined style={{ fontSize: 32, color: "#1890ff" }} />,
    features: [
      { text: "Unlimited products", included: true },
      { text: "Complete analytics suite", included: true },
      { text: "Unlimited locations", included: true },
      { text: "24/7 dedicated support", included: true },
      { text: "Multi-warehouse sync", included: true },
      { text: "Custom reporting", included: true },
    ],
    popular: false,
  },
];

const PackagesPage = () => {
  return (
    <Layout className="packages-page">
      <Content style={{ marginTop: 64, padding: "0 50px" }}>
        {/* Hero Section */}
        <section className="hero-section" style={{ padding: "60px 0", textAlign: "center" }}>
          <Title level={1} style={{ fontSize: "48px", marginBottom: "16px" }}>
            Choose Your SellSmart Plan
          </Title>
          <Paragraph style={{ fontSize: "18px", maxWidth: "800px", margin: "0 auto" }}>
            Select the perfect package for your retail business needs. All plans include our core
            inventory and sales tracking features with different levels of capacity and support.
          </Paragraph>
        </section>

        {/* Packages Section */}
        <section className="packages-section" style={{ padding: "40px 0" }}>
          <Row gutter={[24, 24]} justify="center">
            {packages.map((pkg, index) => (
              <Col xs={24} sm={24} md={12} lg={8} key={index}>
                <Card
                  hoverable
                  style={{
                    height: "100%",
                    border: pkg.popular ? "2px solid #1890ff" : "1px solid #f0f0f0",
                    position: "relative",
                  }}
                >
                  {pkg.popular && (
                    <Tag
                      color="#1890ff"
                      style={{
                        position: "absolute",
                        top: -12,
                        right: 20,
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                    >
                      MOST POPULAR
                    </Tag>
                  )}
                  <div style={{ textAlign: "center", marginBottom: "24px" }}>
                    {pkg.icon}
                    <Title level={3} style={{ marginTop: "16px", marginBottom: "8px" }}>
                      {pkg.name}
                    </Title>
                    <div style={{ marginBottom: "8px" }}>
                      <Text strong style={{ fontSize: "32px" }}>
                        {pkg.price}
                      </Text>
                      <Text type="secondary">{pkg.period}</Text>
                    </div>
                    <Text type="secondary">{pkg.description}</Text>
                  </div>

                  <Divider />

                  <div style={{ marginBottom: "24px" }}>
                    {pkg.features.map((feature, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "12px",
                          color: feature.included ? "inherit" : "rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        {feature.included ? (
                          <CheckOutlined style={{ color: "#52c41a", marginRight: "8px" }} />
                        ) : (
                          <span style={{ marginRight: "24px" }}>×</span>
                        )}
                        <Text delete={!feature.included}>{feature.text}</Text>
                      </div>
                    ))}
                  </div>

                  <Button
                    type={pkg.popular ? "primary" : "default"}
                    block
                    size="large"
                  >
                    Get Started
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* Enterprise Solution Section */}
        <section
          className="enterprise-section"
          style={{ padding: "60px 0", textAlign: "center" }}
        >
          <Title level={2} style={{ marginBottom: "16px" }}>
            Need a Custom Enterprise Solution?
          </Title>
          <Paragraph style={{ fontSize: "16px", maxWidth: "800px", margin: "0 auto 24px" }}>
            We offer tailored solutions for large retail chains with complex requirements.
            Contact us to discuss your specific needs.
          </Paragraph>
          <Button type="primary" size="large">
            Contact Sales
          </Button>
        </section>
      </Content>
    </Layout>
  );
};

export default PackagesPage;